export default {"src":"/_next/static/media/compute.73a593e6.svg","height":94,"width":94};